import { Avatar, makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
  legenda: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
  },
  bola: {
    borderRadius: '50%',
    height: '8px',
    width: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
  },
}));

export const StyledAvatar = styled(Avatar)`
  margin: 10px 24px 0px 24px;
  border: 3px solid ${(props) => props.color};
  width: 104px !important;
  height: 104px !important;
`;
